// Beer Brands - Ranked by Global Sales Volume
export const BEER_BRANDS_CARDS = [
  { id: 1, name: "Snow", rank: 1, image: "/images/beerBrands/snow.png" },
  { id: 2, name: "Budweiser", rank: 2, image: "/images/beerBrands/budweiser.png" },
  { id: 3, name: "Heineken", rank: 3, image: "/images/beerBrands/heineken.png" },
  { id: 4, name: "Stella Artois", rank: 4, image: "/images/beerBrands/stella_artois.png" },
  { id: 5, name: "Corona", rank: 5, image: "/images/beerBrands/corona.png" },
  { id: 6, name: "Skol", rank: 6, image: "/images/beerBrands/skol.png" },
  { id: 7, name: "Brahma", rank: 7, image: "/images/beerBrands/brahma.png" },
  { id: 8, name: "Tsingtao", rank: 8, image: "/images/beerBrands/tsingtao.png" },
  { id: 9, name: "Bud Light", rank: 9, image: "/images/beerBrands/bud_light.png" },
  { id: 10, name: "Guinness", rank: 10, image: "/images/beerBrands/guinness.png" },
  { id: 11, name: "Coors Light", rank: 11, image: "/images/beerBrands/coors_light.png" },
  { id: 12, name: "Miller Lite", rank: 12, image: "/images/beerBrands/miller_lite.png" },
  { id: 13, name: "Asahi", rank: 13, image: "/images/beerBrands/asahi.png" },
  { id: 14, name: "Modelo", rank: 14, image: "/images/beerBrands/modelo.png" },
  { id: 15, name: "Carlsberg", rank: 15, image: "/images/beerBrands/carlsberg.png" },
  { id: 16, name: "Sapporo", rank: 16, image: "/images/beerBrands/sapporo.png" },
  { id: 17, name: "Foster's", rank: 17, image: "/images/beerBrands/fosters.png" },
  { id: 18, name: "Beck's", rank: 18, image: "/images/beerBrands/becks.png" },
  { id: 19, name: "Peroni", rank: 19, image: "/images/beerBrands/peroni.png" },
  { id: 20, name: "Amstel", rank: 20, image: "/images/beerBrands/amstel.png" },
  { id: 21, name: "Dos Equis", rank: 21, image: "/images/beerBrands/dos_equis.png" },
  { id: 22, name: "Pacifico", rank: 22, image: "/images/beerBrands/pacifico.png" },
  { id: 23, name: "Tecate", rank: 23, image: "/images/beerBrands/tecate.png" },
  { id: 24, name: "Blue Moon", rank: 24, image: "/images/beerBrands/blue_moon.png" },
  { id: 25, name: "Sam Adams", rank: 25, image: "/images/beerBrands/sam_adams.png" },
  { id: 26, name: "Yuengling", rank: 26, image: "/images/beerBrands/yuengling.png" },
  { id: 27, name: "Sierra Nevada", rank: 27, image: "/images/beerBrands/sierra_nevada.png" },
  { id: 28, name: "Pabst Blue Ribbon", rank: 28, image: "/images/beerBrands/pabst_blue_ribbon.png" },
  { id: 29, name: "Newcastle", rank: 29, image: "/images/beerBrands/newcastle.png" },
  { id: 30, name: "Rolling Rock", rank: 30, image: "/images/beerBrands/rolling_rock.png" }
];
